<template>
  <ul class="pagination">
    <li class="page-cursor" v-show="current !== 1" @click="goto(current - 1)">
      <a rel="external nofollow">上一页</a>
    </li>
    <li class="page-cursor" v-for="index in pages" @click="goto(index)" :class="{'active':current === index}" :key="index">
      <a rel="external nofollow">{{ index }}</a>
    </li>
    <li class="page-cursor" v-show="allPage !== current && allPage !== 0" @click="goto(current + 1)">
      <a rel="external nofollow">下一页</a>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    currentPage: Number,
    showItemPerPage: Number,
    totalPage: Number,
    callBack: Function
  },
  name: "PageFen",
  data() {
    return {
      pages: [],
      current: this.currentPage, // 当前页码
      showItem: this.showItemPerPage, // 最少显示5个页码
      allPage: this.totalPage // 总共的
    }
  },
  mounted() {
    this.calPages()
  },
  watch: {
    totalPage: function() {
      this.allPage = this.totalPage
      this.calPages()
    }
  },
  methods: {
    goto(index) {
      this.callBack(index)
      this.current = index
      this.calPages()
    },
    calPages() {
      let pag = []
      let i = 0
      if (this.current < this.showItem) { //如果当前的激活的项 小于要显示的条数
        //总页数和要显示的条数那个大就显示多少条
        i = Math.min(this.showItem, this.allPage)
        while (i) {
          pag.unshift(i--)
        }
      } else { //当前页数大于显示页数了
        let middle = this.current - Math.floor(this.showItem / 2) //从哪里开始
        i = this.showItem;
        if (middle > (this.allPage - this.showItem)) {
          middle = (this.allPage - this.showItem) + 1
        }
        while (i--) {
          pag.push(middle++);
        }
      }
      this.pages = pag
    }
  }
}
</script>

<style scoped>
li {
  list-style: none;
}

a {
  text-decoration: none;
}

.pagination {
  position: relative;
}

.pagination li {
  display: inline-block;
  margin: 0 5px;
}

.pagination li a {
  padding: .2rem .5rem;
  display: inline-block;
  border: 1px solid #ddd;
  background: #fff;
  color: #333333;
}

.pagination li a:hover {
  background: #eee;
}

.pagination li.active a {
  background: #00b4ac;
  color: #ffffff;
}
.page-cursor {
  cursor: pointer;
}
</style>